import { render } from "./Topbar.vue?vue&type=template&id=b7056a0a&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"

import "./Topbar.vue?vue&type=style&index=0&id=b7056a0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7056a0a"

export default script